/*
 * @Author: 魏强(2018.2.1)
 * @Date: 2020-10-30 14:21:01
 * @Last Modified by: 李志远
 * @Last Modified time: 2022-10-Tu 05:27:52
 * @title: 人气热推
 */

<template>
  <div class="home-module mb">
    <h3 class="module-title"><span>人气热推</span></h3>
    <div class="hotSale clearfix">
      <div class="hotSale-item" v-for="(store,index) in hotPersonalStoreList" v-if="index<4" :key="store.storeId">
        <router-link :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank">
          <img :src="store.storeBanner" class="hotSale-item-img" :alt="store.storeName" />
        </router-link>

        <router-link :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank" class="hotSale-info">
          <img :src="store.storeLogo" width="100" height="50" />
          <p class="hotSale-name">
            <span class="hotSale-store">{{store.storeName}}</span>
            <span class="hotSale-rate">好评率：{{store.praiseRate*100}}%</span>
          </p>
        </router-link>

        <div class="hotSale-hover">
          <div class="hotSale-pro-list clearfix">
            <router-link class="hotSale-hover-pro" v-for="goods in hotPersonalStoreGoodList" v-if="goods.storeId==store.storeId" :key="goods.goods_id || goods.goodsId" :to="{path:'/goods',query:{goods_id:goods.goods_id || goods.goodsId}}" target="_blank">
              <img :src="goods.designImage || goods.design_image" width="140px" height="177px" style="cursor: pointer;" :alt="store.storeName" />
              <span>￥ {{goods.price}}</span>
            </router-link>
          </div>
          <router-link :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank">
            <img :src="store.storeLogo" class="hotSale-hover-logo" width="100" height="50" :alt="store.storeName" />
          </router-link>
          <a @click.stop.prevent="doAdd(store.storeId)" class="hotSale-favorite">收藏本店</a>
          <router-link :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" class="enter-btn" target="_blank">
            进入店铺
          </router-link>
        </div>
        <span class="jpStore"></span>
      </div>
    </div>
  </div>
</template>
<script>
import { addStoreCollections } from 'api/shop.js'
import { mapGetters } from "vuex"
export default {
  props: ['hotPersonalStoreGoodList', 'hotPersonalStoreList'],
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "sid"
    ]),
    // 计算是否已登陆
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    }
  },
  methods: {
    doAdd(storeId) {
      if (!this.isLogin) {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，请先登录！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      } else {
        let data = {
          storeId: storeId,
          type: 2
        }
        addStoreCollections(data).then(json => {
          this.$Message.info(json.resDesc);
        })
      }
    }
  }
}
</script>
<style scoped>
.hotSale-item {
  height: 350px;
}
.hotSale-pro-list {
  height: 202px;
  overflow: hidden;
}
.hotSale-pro-list a {
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// module-reference.vue?fd67fe76